<template>
  <DialogForm :form="form" :loading="loading" placement="left" :rules="rules" submit-text="Submit" title="Feature request" :visible="visible" @submit="submit" @update:visible="hide">
    <p style="margin-bottom: 15px">Using this form you can request new features for the Firenze application</p>

    <VTextarea v-model="form.description" label="Describe your feature" :maxlength="2000" prop="description" :rows="4" />

    <VSelect v-model="form.category" filterable label="Category" required>
      <VOption v-for="label in Object.keys(categories)" :key="label" :label="label" :value="label" />
    </VSelect>

    <VSelect v-model="form.follow_up_email" label="Can we follow-up on this feature request?">
      <VOption v-for="(item, index) in options" :key="index" :label="item.label" :value="item.value" />
    </VSelect>

    <VUpload accept=".jpg,.jpeg,.png,.mp4,.webm,.pdf,.csv,.txt,.json" drag :files="form.attachment" :max="5" multiple :pastable="visible" style="display: inline" @update:files="updateAttachment" />
  </DialogForm>
</template>

<script setup lang="ts">
export interface DialogFeatureRequestForm {
  attachment: File[]
  category: string
  description: string
  follow_up_email: boolean
}

const defaultForm = (): DialogFeatureRequestForm => ({
  attachment: [] as File[],
  category: '',
  description: '',
  follow_up_email: true,
})

const emit = defineEmits<{
  (event: 'update:visible', value: boolean): void
}>()

interface Props {
  visible: boolean
}

const props = defineProps<Props>()

const { categories, categoryChangedByUser, form, hide, loading, options, rules, setDefaultForm, updateAttachment } = useSupportReport(defaultForm, 'featurerequests', props.visible, emit)

async function submit() {
  const formData = new FormData()

  for (const [key, value] of Object.entries(form)) {
    if (key !== 'attachment') formData.append(key, String(value))
  }

  form.attachment.forEach((file, index) => formData.append(`files[${index}]`, file))
  formData.append('title', ((form.description.split('\n')?.[0] ?? '').split('. ')?.[0] ?? '').slice(0, 180))

  loading.value = true
  categoryChangedByUser.value = false
  setDefaultForm()
  await api.post('feature-request', formData)
}
</script>
